import React from "react";
import { useSelector } from "react-redux";

function Presentation(){


    return(
        <div className="shortDescriptionDisplay">
            <div className="shortDescriptionBox">
                <p>
                    <span>Salut ! Je m'appelle Anthony Boschat.</span>
                    <span>
                        En 2022 débute mon parcours d'apprenant développeur web,
                        j'ai fait mes premiers pas en m'initiant à Python, puis assez vite, je me suis plongé dans des langages plus fondamentaux au web : HTML, CSS, JavaScript, PHP, MySQL.
                    </span>
                    <span>Je suis un passionné de science, tout particulièrement de physique.</span>
                    <span>Mon désir de connaissance du fonctionnement du monde, et des systèmes en général, a nourri ma curiosité et mon envie de faire de la programmation, et plus globalement de l'informatique, mon métier.</span>
                    <span>J'accorde beaucoup d'importance à la compréhension et pas seulement à l'apprentissage récitatif : je souhaite me développer une vision plus large de cet univers et acquérir une aisance à son application.</span>
                    <span>Dans mon parcours, j'ai la chance de pouvoir être soutenu et encadré par un mentor qui m'accompagne chaque semaine dans mon apprentissage.</span>
                    <span>Je vous souhaite à tous une agréable visite de mon site.</span>
                </p>
            </div>
        </div>
    )
}

export default Presentation;